import { equals,flip,includes } from 'ramda';

export enum StatusCode {
  VALIDATION_ERROR = 422,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  BAD_REQUEST = 400
}

const isOfStatus = (statusCodes: StatusCode[]): (statusCode: StatusCode) => boolean =>
  flip(includes)(statusCodes);

export const unauthorizedOrForbidden = isOfStatus([StatusCode.UNAUTHORIZED, StatusCode.FORBIDDEN]);

export const isValidationError = equals(StatusCode.VALIDATION_ERROR);
